module.exports = __webpack_public_path__ + "static/media/3Diligent.9b9cbc0b.png";